import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";
import {ACTION_TYPES} from "../consts";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {NoScoresDisplayEvent} from "../models/events/no-scores.display-event";

export class NoScoresDisplayEventHandler extends AnalyticsEventHandler {
  type = ACTION_TYPES.noScoresDisplay;
  analyticsService: AnalyticsService;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = NoScoresDisplayEvent;
  }

  async action(params) {
    const clickEvent: NoScoresDisplayEvent = new NoScoresDisplayEvent(params);

    this.analyticsService.createEvent(clickEvent);
  }
}
